<template>
    <transition name="dialogfade">
        <k-dialog v-if="showDialog"
            class="escrow-holdback-dialog"
            :title="dialogTitle"
            @close="closeDialog">
            <div class="fields__container">
                <div class="input-item" v-for="field in editFields" :key="field.id">
                    <div class="input-row" v-if="field.type !== 'textarea'">
                        <label>{{ field.label }}</label>
                        <k-numeric-input v-if="field.type === 'numeric'" v-model="field.value"></k-numeric-input>
                        <k-datepicker v-if="field.type === 'date'" v-model="field.value"></k-datepicker>
                    </div>
                    <div class="comments" v-if="field.type === 'textarea'">
                        <label>{{ field.label }}</label>
                        <k-textarea v-model="field.value" :rows="5"></k-textarea>
                    </div>
                </div>
            </div>
            <k-dialog-actions>
                <k-button v-bind:class="['dialog__btn dialog__btn--save', { 'dialog__btn--save-active': !saveChangesBtnDisabled }]" v-on:click="saveChanges">{{ saveChangesBtnDisabled ? 'Close' : 'Save and Close' }}</k-button>
            </k-dialog-actions>

            <transition name="dialogfade">
                <k-dialog v-if="showConfirmCloseDialog"
                class="edit-condition-dialog confirm-junk-dialog"
                :title="'You have unsaved changes'"
                @close="toggleConfirmCloseDialog">
                    <p class="confirm-junk--msg">Are you sure you would like to cancel your changes?</p>
                    <k-dialog-actions>
                        <k-button class="dialog__btn dialog__btn--close" v-on:click="toggleConfirmCloseDialog">No</k-button>
                        <k-button class="dialog__btn dialog__btn--save" v-on:click="confirmCloseDialog">Yes</k-button>
                    </k-dialog-actions>
                </k-dialog>
            </transition>
        </k-dialog>
    </transition>
</template>

<script>
    import { Dialog, DialogActionsBar} from '@progress/kendo-vue-dialogs';
    import { Button } from '@progress/kendo-vue-buttons';
    import { NumericTextBox, TextArea } from '@progress/kendo-vue-inputs';
    import { DatePicker } from '@progress/kendo-vue-dateinputs';

    import cloneDeep from 'lodash.clonedeep';
    import isEqual from 'lodash.isequal';

    export default {
        props: ['holdbackFields', 'showDialog'],
        emits: ['dialogclosed', 'fieldsupdated'],
        data() {
            return {
                dialogTitle: 'Escrow Holdback Information',
                editFields: [],
                showConfirmCloseDialog: false,
            }
        },
        computed: {
            saveChangesBtnDisabled() {
                return isEqual(this.holdbackFields, this.editFields);
            }
        },
        watch: {
            showDialog(val) {
                if (val) {
                    this.editFields = cloneDeep(this.holdbackFields);
                    console.log(this.editFields)
                } else {
                    this.showConfirmCloseDialog = false;
                    this.editFields = [];
                }
            }
        },
        methods: {
            closeDialog() {
                if (!this.saveChangesBtnDisabled) return this.toggleConfirmCloseDialog();

                this.$emit('dialogclosed');
            },
            confirmCloseDialog() {
                this.showConfirmCloseDialog = !this.showConfirmCloseDialog;

                this.$emit('dialogclosed');
            },
            saveChanges() {
                if (this.saveChangesBtnDisabled) return this.closeDialog();

                this.$emit('fieldsupdated', cloneDeep(this.editFields));
            },
            toggleConfirmCloseDialog() {
                this.showConfirmCloseDialog = !this.showConfirmCloseDialog;
            }
        },
        components: {
            'k-dialog': Dialog,
            'k-dialog-actions': DialogActionsBar,
            'k-button': Button,
            'k-datepicker': DatePicker,
            'k-textarea': TextArea,
            'k-numeric-input': NumericTextBox
        }
    }
</script>

<style>
    @import '/src/assets/css/editConditionDialog.css';
    @import '/src/assets/css/escrowHoldbackDialog.css';
</style>